import { Typography } from "@mui/material";
import {
  FORM_FIELDS,
  type VesselNominationOutletContext,
} from "@features/vessel-nomination/add/constants";
import type {
  CargoOnboardParcelFormData,
  CargoOnboardParcelValidatedFormData,
} from "@features/vessel-nomination/add/schema/vesselNominationFormSchema";
import Parcels from "@features/vessel-nomination/components/TypeAndQuantityOfCargoSection/Parcels";
import { FormProvider } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";

const LANG_BASE = "vessel-nomination.add.form";

const TypeAndQuantityOfCargoSection = () => {
  const { t } = useTranslation();
  const outletContext = useOutletContext<VesselNominationOutletContext | undefined>();

  if (!outletContext) {
    return null;
  }

  const { formData } = outletContext;
  const parcels = formData.watch(FORM_FIELDS.PARCELS) ?? [];
  const parcelsError = formData.formState.errors[FORM_FIELDS.PARCELS]?.message;

  const setParcels = (updatedParcels: CargoOnboardParcelFormData[]) => {
    const validatedParcels = updatedParcels as CargoOnboardParcelValidatedFormData[];

    formData.setValue(FORM_FIELDS.PARCELS, validatedParcels, {
      shouldDirty: true,
      shouldTouch: true,
      shouldValidate: true,
    });
    outletContext.updateFormData(FORM_FIELDS.PARCELS, validatedParcels);
  };

  const clearParcelsError = () => {
    outletContext.clearErrors(FORM_FIELDS.PARCELS);
  };

  return (
    <FormProvider {...formData}>
      <div className="grid w-full grid-cols-1 gap-4">
        <Typography variant="body2">
          {t(`${LANG_BASE}.sections.type-and-quantity-of-cargo`)}
        </Typography>

        <Parcels
          parcels={parcels}
          parcelsError={typeof parcelsError === "string" ? parcelsError : undefined}
          setParcels={setParcels}
          clearParcelsError={clearParcelsError}
        />
      </div>
    </FormProvider>
  );
};

export default TypeAndQuantityOfCargoSection;
